import styled from "styled-components";

export const ChartLinkWrapper = styled.div`
  .certificate {
    padding-top: 40px;
  }

`;
